var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errors.length > 0)?_c('ul',{staticClass:"ax-form-errors list-unstyled"},_vm._l((_vm.errors),function(error,i){return _c('li',{key:i,staticClass:"ax-form-errors__error",style:(_vm.errorStyle)},[_vm._v(" "+_vm._s(error.message ? error.message : error)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }